export default __webpack_public_path__ + "static/media/EllipseGreen.49d9730a.svg";